// Item #36 — máscara central de dados sensíveis para exportações geradas no
// navegador (GridPadrao etc.) quando a entidade ativa tem lgpd_ocultar_dados = 'S'.
// Espelha GestaoDocumentosBackEnd/utils/lgpdMascara.js — mantenha os dois em sincronia.

export const OCULTO = "[OCULTO LGPD]";

export function mascararCpf(cpf) {
  const digitos = String(cpf || "").replace(/\D/g, "");
  if (digitos.length !== 11) return OCULTO;
  return `***.${digitos.slice(3, 6)}.${digitos.slice(6, 9)}-**`;
}

export function mascararCnpj(cnpj) {
  const digitos = String(cnpj || "").replace(/\D/g, "");
  if (digitos.length !== 14) return OCULTO;
  return `**.${digitos.slice(2, 5)}.${digitos.slice(5, 8)}/****-**`;
}

export function mascararEmail(email) {
  const valor = String(email || "");
  const arroba = valor.indexOf("@");
  if (arroba <= 0) return OCULTO;
  const local = valor.slice(0, arroba);
  const dominio = valor.slice(arroba + 1);
  const localMascarado = local.length > 2 ? `${local.slice(0, 2)}***` : "***";
  return `${localMascarado}@${dominio}`;
}

export function mascararTelefone(telefone) {
  const digitos = String(telefone || "").replace(/\D/g, "");
  if (digitos.length < 8) return OCULTO;
  return `${"*".repeat(digitos.length - 4)}${digitos.slice(-4)}`;
}

export function mascararDataNascimento() {
  return OCULTO;
}

export function mascararTextoLivre() {
  return OCULTO;
}

export function mascararValorMonetario() {
  return OCULTO;
}

// Mascara uma única palavra mantendo a primeira letra (com a caixa original)
// e substituindo o restante por asteriscos — quantidade de asteriscos
// proporcional ao tamanho real da palavra.
function mascararPalavra(palavra) {
  if (palavra.length <= 1) return palavra;
  return `${palavra[0]}${"*".repeat(palavra.length - 1)}`;
}

// Nome completo: mostra só a primeira e a última palavra do nome (nomes do
// meio/preposições — "de", "da" — somem por completo, não viram asteriscos),
// cada uma mascarada como <primeira letra><asteriscos>. Ex.: "João Venâncio de
// Stefani" -> "J*** S******". Decisão confirmada com o usuário em 2026-07-05.
export function mascararNomeCompleto(nome) {
  const partes = String(nome || "").trim().split(/\s+/).filter(Boolean);
  if (partes.length === 0) return OCULTO;
  const primeiro = mascararPalavra(partes[0]);
  if (partes.length === 1) return primeiro;
  const ultimo = mascararPalavra(partes[partes.length - 1]);
  return `${primeiro} ${ultimo}`;
}

const MASCARADORES = {
  cpf: mascararCpf,
  cnpj: mascararCnpj,
  email: mascararEmail,
  telefone: mascararTelefone,
  celular: mascararTelefone,
  data_nascimento: mascararDataNascimento,
  endereco: mascararTextoLivre,
  observacoes: mascararTextoLivre,
  valor_monetario: mascararValorMonetario,
  nome_completo: mascararNomeCompleto,
};

export function mascararValor(valor, tipo) {
  if (valor === null || valor === undefined || valor === "") return valor;
  const mascarador = MASCARADORES[String(tipo || "").trim().toLowerCase()];
  return mascarador ? mascarador(valor) : OCULTO;
}
